import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { Subscription } from "rxjs";

import { LorenFormField } from "../../../loren-entity-form-card/interfaces/loren-form-field.interface";
import { LorenBreakpointObserverService } from "../../../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import { FormFieldInteraction } from "../../../loren-entity-form-card/components/loren-entity-form-card/interfaces/form-field-interaction.interface";
import { LorenDateUtilsService } from "../../../../services/loren-date-utils-service/loren-date-utils.service";

@Component({
    selector: "loren-date-field",
    templateUrl: "./loren-date-field.component.html",
    styleUrls: ["./loren-date-field.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenDateFieldComponent implements OnInit, OnDestroy {
  private breakpointObserverService = inject(LorenBreakpointObserverService);

  @Input() formGroup: UntypedFormGroup;
  @Input() field: LorenFormField;
  @Input() maxDate = LorenDateUtilsService.getMomentNow();
  @Output() fieldInteraction = new EventEmitter<FormFieldInteraction>(null);

  isHandset: boolean;

  private handsetSubscription: Subscription;

  ngOnInit(): void {
    this.handsetSubscription = this.breakpointObserverService
      .getHandsetStateSubscription()
      .subscribe((x) => (this.isHandset = x));
  }

  handleFormFieldInteraction(
    $event: MatDatepickerInputEvent<unknown>,
    field: LorenFormField
  ) {
    this.fieldInteraction.emit({
      fieldName: field.name,
      fieldCurrentValue: $event.value,
    });
  }

  ngOnDestroy(): void {
    this.handsetSubscription.unsubscribe();
  }
}
